import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import loader from '../assets/images/loader-ring.svg';

const Loader = () => {
    return (
        <Container>
            <Row className='d-flex justify-content-center'>
                <Col>
                    <div className="LoadingOverlay center-screen">
                        <img src={loader} alt="" className="loader-size"/>
                    </div>
                </Col>
            </Row> 
        </Container>
    );
};

export default Loader;